import React from 'react'

class User extends React.PureComponent {
  render() {
    const {url, user: {login, html_url, avatar_url}} = this.props
    return (
      <a className="user" href={url || html_url} target={url ? '' : '_blank'} key={login}>
        <img src={avatar_url} alt={login} />
        {login}
      </a>
    )
  }
}

export default User
